'use client';

// Set __DEV__ global for client-side code.
// This runs at module evaluation time, before any component renders.
(globalThis as any).__DEV__ = process.env.NODE_ENV === 'development';

/**
 * Empty component that initializes the __DEV__ global on the client.
 * Include once in the root layout. Renders nothing.
 */
export function DevInit() {
  return null;
}
